export default __webpack_public_path__ + "static/media/30days-calender-mobile.4f8b9a93.webp";